import { params as paramConstants } from './';

export const getImageFileName = (job, paramsByJobId) => {
  const params = paramsByJobId[job.id];
  if (!params) {
    return undefined;
  }

  return params[paramConstants.IMAGEFILE];
};

export const getJobNameNumber = (job) => `${job.name}_${job.number}`;
export const getJobNumber = (jobNameNumber) =>
  jobNameNumber.slice(jobNameNumber.lastIndexOf('_') + 1);
export const WS_PREFIX = '\\\\workspaces\\workspaces';


// WEBPACK FOOTER //
// src/helpers/job.js